import { render } from "./EnRestrictedAccessIcon.vue?vue&type=template&id=282c11da"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/icons/EnRestrictedAccessIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "282c11da"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('282c11da', __exports__)) {
    api.reload('282c11da', __exports__)
  }
  
  module.hot.accept("./EnRestrictedAccessIcon.vue?vue&type=template&id=282c11da", () => {
    api.rerender('282c11da', render)
  })

}


export default __exports__